import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { TipoEquipamentoDBService } from '../database/tipo-equipamento-db.service';

@Injectable({
  providedIn: 'root'
})
export class TipoEquipamentoService extends BaseService{
    override classname: string = 'TipoEquipamentoService';
    public override route: string = 'tipo-equipamento';
    public override database = new TipoEquipamentoDBService();
}
